import React, { useReducer } from "react";
import axios from "axios";
import MonitoringContext from "./MonitoringContext";
import MonitoringReducer from "./MonitoringReducer";
import {
  SET_LOADING,
  GET_MONITORING,
  GET_MONITORING_ERROR,
  GET_DUPLICATED_EMAIL,
  GET_MISSING_PAYMENTS,
  GET_PENDING_PAYMENTS,
} from "../types";

const DashboardState = (props) => {
  const initialState = {
    loading: false,
    monitorings: null,
    duplicateds: null,
    missings: null,
    pendings: null,
    error: null,
  };

  const [state, dispatch] = useReducer(MonitoringReducer, initialState);

  // Set Loading
  const setLoading = () =>
    dispatch({
      type: SET_LOADING,
    });

  // Get Monitoring Data
  const getMonitorings = async () => {
    setLoading(true);
    try {
      const res = await axios.post("/api/monitoring/get-monitoring");
      dispatch({
        type: GET_MONITORING,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GET_MONITORING_ERROR,
        payload: err.response,
      });
    }
  };

  // Get Duplicated Email
  const getDuplicated = async () => {
    setLoading(true);
    try {
      const res = await axios.post("/api/monitoring/get-duplicated-email");
      dispatch({
        type: GET_DUPLICATED_EMAIL,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GET_MONITORING_ERROR,
        payload: err.response,
      });
    }
  };

  // Get Missing Payments
  const getMissingPayments = async () => {
    setLoading(true);
    try {
      const res = await axios.post("/api/monitoring/get-missing-payments");
      dispatch({
        type: GET_MISSING_PAYMENTS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GET_MONITORING_ERROR,
        payload: err.response,
      });
    }
  };

  // Get Pending Payments
  const getPendingPayments = async () => {
    setLoading(true);
    try {
      const res = await axios.post("/api/monitoring/get-pending-payments");
      dispatch({
        type: GET_PENDING_PAYMENTS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GET_MONITORING_ERROR,
        payload: err.response,
      });
    }
  };

  return (
    <MonitoringContext.Provider
      value={{
        loading: state.loading,
        monitorings: state.monitorings,
        duplicateds: state.duplicateds,
        missings: state.missings,
        pendings: state.pendings,
        error: state.error,
        setLoading,
        getMonitorings,
        getDuplicated,
        getMissingPayments,
        getPendingPayments,
      }}
    >
      {props.children}{" "}
    </MonitoringContext.Provider>
  );
};

export default DashboardState;
